.board {
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  height: 100dvh;
  min-height: 0;
  padding: var(--gap);
  overflow-x: hidden;
  overflow-y: auto;
}
.header {
  display: flex;
  align-items: baseline;
  border-bottom: 1px solid var(--edge);
  padding-bottom: var(--gap);
  flex: 0 0 auto;
}
.attentionRail {
  display: flex;
  align-items: flex-start;
  gap: 0.45em;
  margin-inline-start: auto;
  padding: 0.35em 0.55em;
  border: 0.14rem solid var(--status-critical);
  border-radius: var(--radius);
  color: var(--ink-primary);
  background: var(--surface-raised);
  font-size: 0.7em;
  line-height: 1.3;
}
.attentionRail ul {
  margin: 0;
  padding-left: 1.1em;
}
.attentionRail a {
  color: inherit;
  text-decoration-color: var(--status-critical);
}
.attentionRail a:focus-visible {
  outline: 0.14rem solid var(--ink-primary);
  outline-offset: 0.12rem;
}
.attentionGlyph {
  color: var(--status-critical);
}
.attention-beacon {
  outline: 0.16rem solid var(--status-critical);
  outline-offset: -0.16rem;
  animation: attention-beacon 1.8s ease-in-out infinite;
}
.attention-alarm {
  outline: 0.22rem solid var(--status-critical);
  outline-offset: -0.22rem;
  animation: attention-alarm 0.75s steps(2, jump-none) infinite;
}
.attention-alarm .attentionRail {
  background: color-mix(in srgb, var(--status-critical) 18%, var(--surface-raised));
}
.attention-steady {
  outline: 0.22rem solid var(--status-critical);
  outline-offset: -0.22rem;
}
@keyframes attention-beacon {
  50% {
    outline-color: var(--status-serious);
  }
}
@keyframes attention-alarm {
  50% {
    outline-color: var(--ink-primary);
  }
}
@media (prefers-reduced-motion: reduce) {
  .attention-beacon,
  .attention-alarm {
    animation: none;
    outline: 0.22rem solid var(--status-critical);
    outline-offset: -0.22rem;
  }
}
.title {
  margin: 0;
  font-size: 1.75em;
  font-weight: 650;
  letter-spacing: -0.01em;
}
.grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  grid-template-rows: repeat(12, minmax(0, 1fr));
  grid-auto-rows: minmax(0, 1fr);
  gap: var(--gap);
  flex: 1;
  min-height: 0;
  align-content: stretch;
}
.footerTools {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.layoutWarning {
  position: relative;
}
.layoutWarningButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.2em;
  min-width: 2em;
  min-height: 2em;
  border: 1px solid var(--status-warning);
  border-radius: 50%;
  color: var(--status-warning);
  background: var(--surface-raised);
  font: inherit;
  cursor: pointer;
}
.layoutWarningButton:hover,
.layoutWarningButton:focus-visible {
  background: var(--surface);
}
.layoutWarningDialog {
  position: absolute;
  z-index: 10;
  right: 0;
  bottom: calc(100% + 0.75rem);
  width: min(32rem, calc(100vw - 2 * var(--gap)));
  padding: 0.8rem;
  border: 1px solid var(--status-warning);
  border-radius: var(--radius);
  color: var(--ink-secondary);
  background: var(--surface-raised);
  box-shadow: 0 0.5rem 1.5rem rgb(0 0 0 / 35%);
}
.layoutWarningHeading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.layoutWarningHeading strong {
  color: var(--status-warning);
}
.layoutWarningDialog p {
  margin: 0.6rem 0;
}
.layoutWarningDialog ul {
  margin: 0.35rem 0 0.75rem;
  padding-left: 1.25rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.85em;
}
.layoutWarningClose {
  border: 0;
  color: var(--ink-muted);
  background: transparent;
  font-size: 1.25em;
  line-height: 1;
  cursor: pointer;
}
.layoutWarningDownloads {
  display: grid;
  gap: 0.35rem;
}
.layoutWarningDownloads button {
  border: 1px solid var(--edge);
  border-radius: 0.25rem;
  background: var(--surface-raised);
  color: var(--ink-secondary);
  font: inherit;
  padding: 0.3em 0.55em;
  text-align: center;
  text-decoration: none;
}
.layoutWarningDownloads button:hover,
.layoutWarningDownloads button:focus-visible {
  border-color: var(--ink-secondary);
  color: var(--ink-primary);
}
.layoutWarningNote {
  color: var(--ink-muted);
  font-size: 0.85em;
}
.footer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  color: var(--ink-muted);
  font-size: 0.75em;
  flex: 0 0 auto;
}
@media (max-width: 64rem) {
  .board {
    height: auto;
    min-height: 100dvh;
    overflow: visible;
  }
  .grid {
    grid-template-columns: 1fr;
    grid-template-rows: none;
    grid-auto-rows: auto;
    flex: 0 0 auto;
    min-height: auto;
  }
  .header {
    align-items: flex-start;
    flex-direction: column;
  }
  .attentionRail {
    margin-inline-start: 0;
  }
  .layoutWarningDialog {
    position: fixed;
    right: var(--gap);
    bottom: calc(var(--gap) + 3rem);
  }
}
